var scope_0 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/179cced02ba0d48ac1a86ebd4b97573e.js').default;
var scope_1 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/190242104f89d4e0f11f38ed1753dbbe.js').default;
var scope_2 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/2982cc71a7ba25932377cf3890b1f6a8.js').default;
var scope_3 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/298e4bf98585b9ad44479b9fb5991197.js').default;
var scope_4 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/339cbaf0fc1660a77ff8ac2815076e85.js').default;
var scope_5 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/348dcb1b15f77a85e32ba154b6bfe161.js').default;
var scope_6 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/3e59c73d84066dc37fbd2214d3ed1000.js').default;
var scope_7 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/4299a41c617c39fb74348f0418efc062.js').default;
var scope_8 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/51b70d9097865bd9a07524bb5e5beeeb.js').default;
var scope_9 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/52adfc1a8e36f8f0f10a1636add25b71.js').default;
var scope_10 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/592b8f494825d9254937e3540c6d0a01.js').default;
var scope_11 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/593cf5c58857b07ec661349be9cd9dd0.js').default;
var scope_12 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/63ea1715ff0952482304c5e12e02a3f5.js').default;
var scope_13 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/650483652ca33b0dc1b13df80d7dc7ad.js').default;
var scope_14 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/651c6630c68fa2833a0b72fae53f5b6c.js').default;
var scope_15 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/679b3070cb36c834a2bf485ad2324b44.js').default;
var scope_16 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6a418e91920f2ddf3fe2da08ebdb34c8.js').default;
var scope_17 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/780b8cbae89c4d364c934a62cc390e88.js').default;
var scope_18 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/89568a44946116be544878f663f0ee5a.js').default;
var scope_19 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/99c470974837e95d8eae235f608ea536.js').default;
var scope_20 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9dd2b609618b59cddfeb641536954ce5.js').default;
var scope_21 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c141b47a9b04a68de1ecef19f5496516.js').default;
var scope_22 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d04e1aec8e415fbe55e3a72832112fef.js').default;
var scope_23 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d222369c85dcd9964fb4ec1b4f7652ef.js').default;
var scope_24 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e4a3edb25a4a9cd96e507f74134e7adf.js').default;
var scope_25 = require('/home/runner/work/design/design/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14,
scope_15,
scope_16,
scope_17,
scope_18,
scope_19,
scope_20,
scope_21,
scope_22,
scope_23,
scope_24,
scope_25 )
    